export default {
  YEARLY: "y",
  QUARTERLY: "q",
  MONTHLY: "m",
  WEEKLY: "w"
};
